// extracted by mini-css-extract-plugin
export default {"centered":"position-module--centered--0d481"};